var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibile && _vm.mostra)?_c('span',{staticClass:"chip-login-wrap"},[_vm._v(_vm._s(_vm.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }